<template>
  <main class="login-container min-h-screen w-full flex items-center justify-center" data-testid="login-page">
    <Login class="max-w-lg" @login-success="onLoginSuccess" />
  </main>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'blank',
})

const route = useRoute()
const { onLoginSuccess } = useUser()
</script>

<style scoped>
.login-container {
  background: linear-gradient(180deg, #082f49 0%, #0c4a6e 50%, #082f49 100%), #fff;
}
</style>
